import Spinner from '~/components/spinner'
import useRetryablePostJSON from '~/hooks/use_retryable_post_json'
import { usdFormat } from '~/utils/currency'

export default function ChartInsight({ url, params, title, subtitle }) {
  const { data, isLoading } = useRetryablePostJSON({ path: url, params })

  return (
    <div className='position-relative h-100 pt-2'>
      {isLoading && <Spinner />}
      {!isLoading && (
        <>
          <h4 className='my-5 text-center'>{title}</h4>
          <div className='text-center'>
            <small style={{ color: '#6c757d' }}>{subtitle}</small>
          </div>
          <p className='text-center'>
            <span style={{ fontSize: '3.43em' }}>{usdFormat(data.data.value)}</span>
          </p>
        </>
      )}
    </div>
  )
}
